import combineClassnames from "classnames";
import classNames from "classnames/bind";
import styles from "./kicker.module.css";

export const kickerKinds = [
  "underlined",
  "underlined-sugarfree",
  "bare",
  "tag-sugarfree",
] as const;

export type KickerKind = (typeof kickerKinds)[number];

const cx = classNames.bind(styles);

export const Kicker = ({
  text,
  className,
  kind,
  ref,
}: {
  text: string | null;
  className?: string;
  kind: KickerKind;
  ref?: React.RefObject<HTMLSpanElement | null>;
}) => (
  <span
    ref={ref}
    className={combineClassnames(
      className,
      cx("container", `container--${kind}`),
    )}
  >
    {text}
  </span>
);
